import React from "react";
import {
  Carousel,
  Typography,
  Button,
  IconButton,
} from "@material-tailwind/react";
import MainCarouselData from "../../models/MainCarouselData";
import SoundImage from "../../assets/images/CarouselHome/sound.mp4";
import FragranceImage from "../../assets/images/CarouselHome/fragrance.mp4";
import LightImage from "../../assets/images/CarouselHome/light.mp4";
import { Link } from "react-router";

import { motion } from "framer-motion";
import { fadeIn } from "../animation/Variants";

function MainCarousel() {
  return (
    <Carousel
      autoplay={true}
      transition={{ type: "tween", duration: 0.85 }}
      loop={true}
      // nextArrow={()=>false}
      // prevArrow={()=>{false}}
      className="h-96 md:h-screen"
    >

      <div className="relative h-full w-full">
        {/* <img
          src={LightImage}
          alt="image 2"
          className="h-full w-full object-cover"
        /> */}

        <div className=" w-[100%]  overflow-hidden">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute top-0 left-0 w-[100%] h-[100%] object-cover -z-10"
          >
            <source src={LightImage} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="absolute inset-0 grid h-full w-full items-center bg-black/15">
         
         
          <div className="absolute w-full flex justify-center xl:-mt-96 md:-mt-72 -mt-60">
            <p className="tracking-widest xl:text-[1.2rem] text-[0.9rem]  uppercase text_CormorantGaramond-Regular text-white">Ceylon Hospital Wellness</p>
          </div>
         
         
         
          <div className="w-3/4 pl-12 md:w-2/4 md:pl-20 lg:pl-32">
            <motion.div
              variants={fadeIn("down", 0.2)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              aria-hidden="true"
            >
              <Typography
                variant="h1"
                color="white"
                className="mb-4 mt-10 uppercase title_DMSerifText-Regular text-3xl md:text-4xl lg:text-5xl"
              >
                Light
              </Typography>
            </motion.div>

            <motion.div
              variants={fadeIn("left", 0.2)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              aria-hidden="true"

            >
              <Typography
                variant="lead"
                color="white"
                className="mb-12 text_CormorantGaramond-Regular font-thin opacity-80 lg:text-2xl leading-tight"
              >
                Light Description that subtle something, that quality of air
                that emanation from old trees, that so wonderfully changes and
                renews a weary spirit.
              </Typography>
            </motion.div>

            <div className="flex gap-2 -mt-8">
              <Link to={"/Categories"}>
                <Button size={"md"} color="white" className="">
                  Explore
                </Button>
              </Link>
              <Link to={"/gallery"}>
                <Button size={"md"} color="white" variant="text">
                  Gallery
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="relative h-full w-full">
        {/* <img
          src={FragranceImage}
          alt="image 1"
          className="h-full w-full object-cover"
        /> */}

        <div className=" w-[100%]  overflow-hidden">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute top-0 left-0 w-[100%] h-[100%] object-cover -z-10"
          >
            <source src={FragranceImage} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="absolute inset-0 grid h-full w-full place-items-center bg-black/40">
        
        
        <div className="absolute w-full flex justify-center xl:-mt-96 md:-mt-72 -mt-60">
            <p className="tracking-widest xl:text-[1.2rem] text-[0.9rem]  uppercase text_CormorantGaramond-Regular text-white">Ceylon Hospital Wellness</p>
          </div>

          <div className="w-3/4 text-center md:w-2/4">
            <motion.div
              variants={fadeIn("down", 0.2)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              aria-hidden="true"
            >
              <Typography
                variant="h1"
                color="white"
                className="mb-4 mt-10 uppercase title_DMSerifText-Regular text-3xl md:text-4xl lg:text-5xl"
              >
                Fragrance
              </Typography>
            </motion.div>

            <motion.div
              variants={fadeIn("up", 0.2)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              aria-hidden="true"

            >
              <Typography
                variant="lead"
                color="white"
                className="mb-12 text_CormorantGaramond-Regular font-thin opacity-80 lg:text-2xl leading-tight"
              >
                Sound description as for that subtle something, that quality of
                air that emanation from old trees, that so wonderfully changes
                and renews a weary spirit.
              </Typography>
            </motion.div>

            <div className="flex justify-center gap-2">
              <Link to={"/Categories"}>
                <Button size={"md"} color="white">
                  Explore
                </Button>
              </Link>
              <Link to={"/gallery"}>
                <Button size={"md"} color="white" variant="text">
                  Gallery
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="relative h-full w-full">
        {/* <img
          src={SoundImage}
          alt="image 3"
          className="h-full w-full object-cover"
        /> */}

        <div className=" w-[100%]  overflow-hidden">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute top-0 left-0 w-[100%] h-[100%] object-cover -z-10"
          >
            <source src={SoundImage} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="absolute inset-0 grid h-full w-full items-center bg-black/40">
        
        <div className="absolute w-full flex justify-center xl:-mt-96 md:-mt-72 -mt-60">
            <p className="tracking-widest xl:text-[1.2rem] text-[0.9rem]  uppercase text_CormorantGaramond-Regular text-white">Ceylon Hospital Wellness</p>
          </div>

          <div className="ml-auto w-3/4 pr-12 md:w-2/4 md:pr-20 lg:pr-32 text-right">
            <motion.div
              variants={fadeIn("down", 0.2)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              aria-hidden="true"
            >
              <Typography
                variant="h1"
                color="white"
                className="mb-4 mt-10 uppercase  title_DMSerifText-Regular text-3xl md:text-4xl lg:text-5xl"
              >
                Sound
              </Typography>
            </motion.div>

            <motion.div
              variants={fadeIn("right", 0.2)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              aria-hidden="true"
            >
              <Typography
                variant="lead"
                color="white"
                className="mb-12 text_CormorantGaramond-Regular font-thin opacity-80 lg:text-2xl leading-tight"
              >
                Sound Description that subtle something, that quality of air
                that emanation from old trees, that so wonderfully changes and
                renews a weary spirit.
              </Typography>
            </motion.div>

            <div className="flex gap-2 justify-end -mt-8">
              <Link to={"/Categories"}>
                <Button size={"md"} color="white">
                  Explore
                </Button>
              </Link>
              <Link to={"/gallery"}>
                <Button size={"md"} color="white" variant="text">
                  Gallery
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* {MainCarouselData.map((item) => (
        <div key={item} className="relative h-full w-full">
          <img
            src={item.src}
            alt="image 1"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 grid h-full w-full items-center bg-black/40">
            <div className="w-3/4 pl-12 md:w-2/4 md:pl-20 lg:pl-32">
              <Typography
                variant="h1"
                color="white"
                className="mb-4 text-3xl md:text-4xl lg:text-5xl"
              >
                {item.title}
              </Typography>
              <Typography
                variant="lead"
                color="white"
                className="mb-12 opacity-80"
              >
                {item.description}
              </Typography>
              <div className="flex gap-2">
                <Button size="lg" color="white">
                  Explore
                </Button>
                <Button size="lg" color="white" variant="text">
                  Gallery
                </Button>
              </div>
            </div>
          </div>
        </div>
      ))} */}
    </Carousel>
  );
}

export default MainCarousel;
